import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Button,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import Search from "./Search";

function Header() {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 600) {
        setDrawerOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // دالة لإنشاء أزرار القائمة
  const renderButton = (to, label, Icon) => (
    <Button
      fullWidth
      color="inherit"
      component={Link}
      to={to}
      onClick={toggleDrawer(false)}
      sx={{
        justifyContent: "flex-end",
        gap: "10px",
        backgroundColor: location.pathname === to ? "#f1f3f5" : "",
      }}
    >
      {label}
      <Icon sx={{ color: "#1779ca", fontSize: "24px" }} />
    </Button>
  );

  return (
    <>
      <div
        style={{
          width: "87.6%",
          display: "flex",
          justifyContent: "center",
          margin: "auto",
        }}
      >
        <Search />
      </div>

      {/* الجزء العلوي */}
      <div dir="rtl" style={{ background: "#1779ca" }}>
        <div
          style={{
            width: "65%",
            margin: "auto",

            maxHeight: 150,
            color: "white",
            position: "relative",
          }}
        >
          <Toolbar>
            {/* أيقونة القائمة للجوال */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{
                display: { xs: "block", sm: "none" },
                position: "absolute",
                right: 0,
                marginTop: "4%",
              }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>

            {/* الشعار */}
            <Typography
              sx={{
                marginBottom: { xs: "10.5px", sm: 1.5 },
                marginTop: { xs: 2.5, sm: 2.5 },
                flexGrow: 1,
                textAlign: { xs: "center", sm: "right" },
              }}
            >
              <img
                src="/logo.png"
                width="183"
                height="auto"
                alt="كوبون أول طلب"
              />
            </Typography>
          </Toolbar>
        </div>
      </div>

      {/* الجزء السفلي */}
      <div
        dir="rtl"
        style={{
          width: "65%",
          margin: "auto",
          color: "black",
          borderBottomLeftRadius: "9px",
          borderBottomRightRadius: "9px",
          backgroundColor: "#f9f9f9",
          boxShadow: "0 1px 1px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          <Button
            style={{
              fontSize: "17px",
              backgroundColor: location.pathname === "/" ? "#f1f3f5" : "",
            }}
            color="inherit"
            component={Link}
            to="/"
          >
            الرئيسية
          </Button>
          <div style={{ marginTop: "-5px" }}>|</div>
          <Button
            style={{
              fontSize: "17px",
              backgroundColor: location.pathname === "/stores" ? "#f1f3f5" : "",
            }}
            color="inherit"
            component={Link}
            to="/stores"
          >
            جميع المتاجر
          </Button>
          <div style={{ marginTop: "-5px" }}>|</div>
          <Button
            style={{
              fontSize: "17px",
              backgroundColor: location.pathname === "/blog" ? "#f1f3f5" : "",
            }}
            color="inherit"
            component={Link}
            to="/blog"
          >
            المدونة
          </Button>
          <div style={{ marginTop: "-5px" }}>|</div>
          <Button
            style={{
              fontSize: "17px",
              backgroundColor:
                location.pathname === "/contact" ? "#f1f3f5" : "",
            }}
            color="inherit"
            component={Link}
            to="/contact"
          >
            اتصل بنا
          </Button>
        </Toolbar>
      </div>
      {/* Drawer للجوال */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{
          display: { sm: "none" },
          "& .MuiDrawer-paper": { backgroundColor: "#f5f5f5" },
        }}
      >
        <List sx={{ width: 250, marginTop: "10%" }}>
          <Typography
            sx={{
              marginBottom: "10.5px",
              marginTop: "15px",
              textAlign: "center",
            }}
          >
            <img
              src="/logoM.png"
              width="170"
              height="auto"
              alt="كوبون أول طلب"
              loading="lazy"
            />
          </Typography>
          <div
            style={{
              borderTop: "1px solid #D3D3D3",
              marginTop: "15%",
              marginBottom: "10%",
              width: "100%",
            }}
          ></div>
          <ListItem>{renderButton("/", "الرئيسية", HomeIcon)}</ListItem>
          <ListItem>
            {renderButton("/stores", "جميع المتاجر", LocalGroceryStoreIcon)}
          </ListItem>
          <ListItem>
            {renderButton("/blog", "المدونة", ContactMailIcon)}
          </ListItem>
          <ListItem>
            {renderButton("/contact", "اتصل بنا", ContactMailIcon)}
          </ListItem>
        </List>
      </Drawer>
    </>
  );
}

export default Header;
